import { collectionEngineV1 } from '../apis.js';
const billingModelsAPI = collectionEngineV1('/billing-models');
export const del = (id) => billingModelsAPI('DELETE', `/${id}`);
export const patch = (id, patch) => billingModelsAPI('PATCH', `/${id}`, {
    body: patch,
});
export const get = () => billingModelsAPI('GET', `/`);
export const create = (newBillingModel) => billingModelsAPI('POST', `/`, {
    body: newBillingModel,
});
//# sourceMappingURL=billing-models.js.map